import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { WhatsappContext } from './Whatsapp';
import { ContentBodyContext } from '../MainContent';
import swal from 'sweetalert';
import axios from 'axios';
import jwt from 'jwt-decode'

function ChatModalForward() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateWhatsApp, dispatchWhatsApp } = useContext(WhatsappContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext);

    const handleCancelClick = () => {
        dispatchWhatsApp({
            type: "MODALFORWARD",
            modalforward: { status: false, chat: null }
        })

        setRenderContact(initialState)
        setselectedContact(initialSelectedContact)
    }

    const handleOptionChange = (event) => {
        event.preventDefault();
        if (event.target.value !== '') {
            setselectedContact({
                ...selectedContact,
                selected: event.target.value,
                err: null
            })
        } else {
            setselectedContact({
                ...selectedContact,
                err: 'Please select admin contact.'
            })
        }
    }

    const handleForwardClick = (event) => {
        event.preventDefault();
        if (selectedContact.selected == '') {
            setselectedContact({
                ...selectedContact,
                err: 'Please select admin contact.'
            })
        } else if (!selectedContact.isSubmitting) {
            sendMessage()
        }
    }
    const initialSelectedContact = {
        selected: '',
        err: null,
        isSubmitting: false
    }
    const [selectedContact, setselectedContact] = useState(initialSelectedContact)

    const initialState = {
        firsLoad: true,
        contacts: [],
        render: (
            <select name="contact" id="scrollable-contact" className="form-control form-select ml-0 mr-sm-2" required autoFocus disabled onChange={handleOptionChange}   >
                <option disabled selected value="null">Choose Client </option>
            </select>
        ),
    }
    const [renderContact, setRenderContact] = useState(initialState)

    //send message
    const sendMessage = () => {
        setselectedContact({
            ...selectedContact,
            isSubmitting: true
        })
        stateContentBody.socket.emit('whatsapp-chat', {
            id: jwt(localStorage.getItem('token-helpdesk-umy')).work_unit_id,
            token: localStorage.getItem('token-helpdesk-umy'),
            body: {
                action: 'forward',
                file: {
                    mime: null,
                    data: null,
                    name: (stateWhatsApp.modalforward.chat.att != null) ? stateWhatsApp.modalforward.chat.att : null,
                },
                receiver: selectedContact.selected,
                message: `${stateWhatsApp.modalforward.chat.content}\n*~forwarded (${stateWhatsApp.modalforward.chat.username})*`,
            }
        })
    }

    useEffect(() => {
        if (stateWhatsApp.trigger.message == 'whatsapp-chat') {
            if (stateWhatsApp.trigger.status == 'success') {
                handleCancelClick();
            } else {
                setselectedContact({
                    ...selectedContact,
                    isSubmitting: false
                })
            }
        }
    }, [stateWhatsApp.trigger])

    //get contact
    const getContact = () => {
        //get contacts
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get(`/api/v1/helpdesk/setting/contact/contacts`, config)
            .then(res => {
                setRenderContact({
                    ...renderContact,
                    firsLoad: false,
                    contacts: res.data.data
                })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    }
                }
            })
    };

    const [rendermodal, setrendermodal] = useState(<Fragment />)
    useEffect(() => {
        if (stateWhatsApp.modalforward.status == true) {
            if (renderContact.contacts.length <= 0 && renderContact.firsLoad == true) {
                getContact()
            }
            setrendermodal(
                <Fragment>
                    <Modal className="modal-dialog modal-dialog-centered" isOpen={stateWhatsApp.modalforward.status} backdrop={true} keyboard={true} >
                        <ModalHeader toggle={handleCancelClick} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>
                            Forward Message
                            </ModalHeader>
                        <ModalBody>
                            <div className="form-group row">
                                <label htmlFor="contact" className="col-form-label">Receiver</label>
                                <div className="input-group  has-validation">
                                    <select name="role" id="role" className={`form-control form-select  ${selectedContact.err != null ? 'is-invalid' : ''}`} required autoFocus aria-describedby="validationForward" onChange={handleOptionChange} >
                                        <option key={null} value="">Choose Contact</option>
                                        {renderContact.contacts.length > 0 ?
                                            renderContact.contacts.map(cnt => (<option key={cnt.id} value={cnt.phone}>{cnt.username}</option>)) :
                                            <Fragment />}
                                    </select>
                                    <div id="validationForward" className="invalid-feedback">
                                        <small>{selectedContact.err}</small>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={handleForwardClick} disabled={selectedContact.selected == '' ? true : selectedContact.isSubmitting} style={{ textTransform: 'capitalize' }} >{selectedContact.isSubmitting ? '...Forwarding' : 'Forward'} <i className={selectedContact.isSubmitting ? 'fas fa-spinner fa-pulse' : "fas fa-share-square"}></i> </Button>
                            <Button color="secondary" onClick={handleCancelClick} style={{ textTransform: 'capitalize' }}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>
            )
        } else if (stateWhatsApp.modalforward.status == false) {
            setrendermodal(<Fragment />)
        }
    }, [stateWhatsApp.modalforward, renderContact.render, selectedContact, renderContact.contacts])

    return (
        rendermodal
    )
}

export default ChatModalForward
